<div class="h-full flex flex-col justify-between">
    <div class="flex-1 overflow-y-auto pt-3 p-4">
        @if (!layer()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else {
            <div class="pb-6">
                <app-title
                    class="font-medium text-2xl"
                    [title]="layer()!.name"
                    (goToPreviousPage)="
                        fieldInterventionService.toggleFieldInterventionEntityDetailPanel(layer()!.id!)
                    " />

                <div class="px-9">
                    <p class="font-medium text-base pt-2">
                        {{ layerType() }}
                    </p>

                    <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-3 my-8">
                        <div class="flex flex-col">
                            <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                                {{ 'identifierColumn' | transloco }}
                            </p>
                            <p class="!m-0">{{ layer()!.businessIdentifier }}</p>
                        </div>
                        <div class="flex flex-col">
                            <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                                {{ 'numberOfEntities' | transloco }}
                            </p>
                            <p class="!m-0">
                                {{ layer()?.entitiesCount ?? 0 }}
                            </p>
                        </div>
                    </div>

                    <p>
                        <span class="font-normal text-xl"> {{ 'attribute' | transloco: { COUNT: 2 } }}</span>
                    </p>
                    <p class="pt-3">
                        <span class="font-medium text-lg">
                            <fa-icon
                                class="text-secondary"
                                [icon]="['fas', 'star']" />
                            {{ 'favorite' | transloco }}</span
                        >
                    </p>

                    @if (attributesBookmarked()) {
                        <app-layer-data-attributes-list [dataAttributes]="attributesBookmarked()!" />
                    }

                    <p class="">
                        <span class="font-medium text-lg"> {{ 'other' | transloco }}</span>
                    </p>

                    @if (attributesOther()) {
                        <app-layer-data-attributes-list [dataAttributes]="attributesOther()!" />
                    }
                </div>
            </div>
        }
    </div>
    <div class="footer">
        <app-button
            [icon]="['fas', 'eye']"
            [label]="'seeEntities' | transloco"
            [type]="ButtonType.PRIMARY"
            (onClick)="goToEntitiesTable()" />
    </div>
</div>
